var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"novo-img"},[_c('div',{ref:"imgBoxRef",staticClass:"img-box",style:({
      width:(_vm.wWidth||_vm.imgW)+'px',
      height:(_vm.wHeight||_vm.imgH)+'px',
      overflow:(_vm.type=='center'||'cover')?'hidden':'auto',
      backgroundColor:_vm.backgroundColor
    }),on:{"click":_vm.imgClick}},[_c('img',{style:({width:_vm.imgW,height:_vm.imgH,position:((_vm.type==='center')||(_vm.type ==='cover'))?'absolute':'auto'}),attrs:{"id":_vm.imgId,"src":_vm.getSrc(),"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a19a339","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/novo-img/index.vue
// module id = null
// module chunks = 